import React, {Component} from 'react';
import {Reviews, ReadMore} from '../styles/review_panel_styles.js';

export default class ReviewItem extends Component{
  constructor(props){
    super()
    this.state={
      expanded: false
    }
  }

  onReadMoreSelect(){
    let isExpanded = this.state.expanded
    this.setState({expanded: !isExpanded})
  }

  render(){
    let set_review = this.state.expanded ? this.props.full : this.props.short
    let btn_text = this.state.expanded ? "See Less" : "See Full Review"

    return(
      <Reviews>
        {set_review}
        <ReadMore onClick={() => this.onReadMoreSelect()} >
          {btn_text}
        </ReadMore>
      </Reviews>
    )
  }
}
